import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { TITULO_IDIOMA_REG } from "../../../utils/constantes";
import { crearIdioma } from "../../../services/idioma.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { FormHook } from "../../../components/molecules/FormHook";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
import { FormInput } from "../../../components/molecules/FormInput";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";

export const RegistrarIdiomaPage = () => {
  const navigate = useNavigate();
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";
  const [estaCargando, setEstaCargando] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const submit = async (data) => {
    setEstaCargando(true);
    try {
      await crearIdioma(data);
      showAlert({
        callback: () => navigate("/idiomas"),
      });
    } catch (err) {
      const errorMessage = err.response.data.message;
      showErrorAlert({ text: errorMessage })
    } finally {
      setEstaCargando(false);
    }
  };

  return (
    <ContenedorPageTemplate dirIcono={DIR_ICON_MAT} titulo={TITULO_IDIOMA_REG}>
      <FormHook
        handleSubmit={handleSubmit}
        submit={submit}
        className="w-[min(100%,700px)] mx-auto"
      >
        <FormDiv>
          <FormInput
            id="nombre"
            label="Nombre"
            type="text"
            placeholder="Nombre"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: {
                value: 60,
                message: "Súpero la cantidad máxima 60 caracteres",
              },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.nombre}
          />
          <FormInput
            id="sigla"
            label="Sigla"
            type="text"
            placeholder="Codigo"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: {
                value: 20,
                message: "Súpero la cantidad máxima 20 caracteres",
              },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.sigla}
          />
        </FormDiv>
        <SubmitButton estaCargando={estaCargando} text="Guardar" />
      </FormHook>
    </ContenedorPageTemplate>
  );
};
